import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

export function useReferrer() {
  const { href } = useLocation();
  const prevLocRef = useRef(document.referrer ? document.referrer : undefined);
  const currentLocRef = useRef(href);

  useEffect(() => {
    prevLocRef.current = currentLocRef.current;
    currentLocRef.current = href;
  }, [href]);

  // The whole point of the ref pair: reading the previous href must not schedule a render.
  // oxlint-disable-next-line react/refs
  return prevLocRef.current;
}
